import { render, staticRenderFns } from "./tech-skills.vue?vue&type=template&id=11d3534a&scoped=true&"
import script from "./tech-skills.vue?vue&type=script&lang=js&"
export * from "./tech-skills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d3534a",
  null
  
)

export default component.exports